import { render, staticRenderFns } from "./InitTravels.vue?vue&type=template&id=472439e4&scoped=true&"
import script from "./InitTravels.vue?vue&type=script&lang=js&"
export * from "./InitTravels.vue?vue&type=script&lang=js&"
import style0 from "./InitTravels.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InitTravels.vue?vue&type=style&index=1&id=472439e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472439e4",
  null
  
)

export default component.exports